/**
 * useMaterialLibrary – haalt Global Material Library op voor dropdowns en mapping.
 * Gebruik in OrderReviewModal, Material Calculator, etc.
 */

import { useQuery } from '@tanstack/react-query'
import api from '../services/api'

export interface MaterialLibraryItem {
  id: number
  composite_id?: number
  item_type?: string
  naam: string
  display_naam?: string
  code?: string
  [key: string]: unknown
}

interface UseMaterialLibraryOptions {
  type?: 'all' | 'sheet' | 'hardware' | 'composite'
  limit?: number
  search?: string
  enabled?: boolean
}

export function useMaterialLibrary(options: UseMaterialLibraryOptions = {}) {
  const { type = 'all', limit = 2000, search, enabled = true } = options

  const { data: materials = [], isLoading } = useQuery({
    queryKey: ['materialen', 'library', type, limit, search],
    queryFn: async () => {
      const res = await api.get('/materialen/library', {
        params: { type, limit, search: search || undefined },
      })
      return (res.data || []) as MaterialLibraryItem[]
    },
    enabled,
  })

  return { materials, isLoading }
}
